var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAx = function SvgAx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ax_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M166 0h850v850H166z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax_svg__a)",
    transform: "translate(-100)scale(.6024)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0053a5",
    d: "M0 0h1300v850H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffce00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 0h250v850H400z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 300h1300v250H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d21034"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475 0h100v850H475z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 375h1300v100H0z"
  })))));
};
export default SvgAx;